const state = () => ({
  etags: {},
});

const getters = {
  getETag: (state) => (resource) => state.etags[resource] || null,
};

const mutations = {
  setETag(state, { resource, value }) {
    state.etags[resource] = value;
  },
  clearETag(state, resource) {
    delete state.etags[resource];
  },
};

const actions = {
  setETag({ commit }, payload) {
    commit("setETag", payload);
  },
  clearETag({ commit }, resource) {
    commit("clearETag", resource);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
